import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';



export const descargarImagen = (IdElement, nombreArchivo, setLoading = ()=>{},) => {
    setLoading(true);
    const qr = document.getElementById(IdElement);
    html2canvas(qr).then(canvas => {
        var link = document.createElement('a');
        link.href = canvas.toDataURL('image/jpeg', 0.9);
        link.download =nombreArchivo + '.jpeg';
        link.click();
    })
    setLoading(false);
}

export const RedondearNumero = (value, digitos = 2) => {

    if (value) {
        let factor = Math.pow(10, digitos);
        let num = Math.round(value * factor) / factor;
    
        return Number(num?.toFixed(digitos));

    } else {
        return 0
    }
}